// Client-side work-email check for fast feedback. The API repeats the check
// against the same list (public/config/blocked-email-domains.json).

export const WORK_EMAIL_MESSAGE = 'Work email please — we match it to your Microsoft 365 tenant.';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

let listPromise: Promise<string[]> | undefined;
function loadBlocklist(): Promise<string[]> {
  listPromise ??= fetch('/config/blocked-email-domains.json')
    .then((r) => (r.ok ? r.json() : { domains: [] }))
    .then((j: { domains?: unknown }) => (Array.isArray(j.domains) ? j.domains.map(String) : []))
    .catch(() => []);
  return listPromise;
}

export function emailDomain(email: string): string {
  return email.trim().toLowerCase().split('@').pop()!.replace(/\.$/, '');
}

// "gmail.com" blocks gmail.com and its subdomains.
// "yahoo.*"   blocks yahoo.com, yahoo.com.au, yahoo.co.uk, mail.yahoo.com …
export function isBlockedDomain(domain: string, entries: string[]): boolean {
  return entries.some((raw) => {
    const entry = raw.trim().toLowerCase();
    if (!entry) return false;
    if (entry.endsWith('.*')) {
      const base = entry.slice(0, -2);
      return domain.startsWith(base + '.') || domain.includes('.' + base + '.');
    }
    return domain === entry || domain.endsWith('.' + entry);
  });
}

// Returns an error message, or '' when the address is acceptable.
export async function checkWorkEmail(email: string, required = true): Promise<string> {
  const value = email.trim();
  if (!value) return required ? 'Enter your work email.' : '';
  if (!EMAIL_PATTERN.test(value)) return 'Enter a valid email address.';
  const entries = await loadBlocklist();
  return isBlockedDomain(emailDomain(value), entries) ? WORK_EMAIL_MESSAGE : '';
}
